import { render, staticRenderFns } from "./learnerReport.vue?vue&type=template&id=89915daa&"
import script from "./learnerReport.vue?vue&type=script&lang=js&"
export * from "./learnerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89915daa')) {
      api.createRecord('89915daa', component.options)
    } else {
      api.reload('89915daa', component.options)
    }
    module.hot.accept("./learnerReport.vue?vue&type=template&id=89915daa&", function () {
      api.rerender('89915daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/learner-reports/learnerReport.vue"
export default component.exports